// Frontend Helper to communicate with our Cloudflare Pages Function Proxy

interface UploadResponse {
  url: string;
  thumb: string;
  delete_url: string | null;
}

export const imgService = {
  async uploadPhoto(file: File): Promise<UploadResponse> {
    const formData = new FormData();
    formData.append('image', file);

    const response = await fetch('/api/upload-image', {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      let errorMessage = 'Upload failed';
      try {
        const errorJson = await response.json();
        errorMessage = errorJson.error || errorMessage;
      } catch {
        errorMessage = `HTTP error! status: ${response.status}`;
      }
      throw new Error(errorMessage);
    }

    const data: UploadResponse = await response.json();
    return data;
  }
};